import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { setAllSearch, setHotel, setTripType } from '../../redux/currentSearch/actions';
import { isCurrentSearchPopulated, getTripType } from '../../redux/currentSearch/selectors';
import { getFilteredPreviousSearches } from '../../redux/previousSearch/selectors';
import { getGeoLocatedSearch } from '../../redux/geoLocations/selectors';
import {
    Config,
    DateUtils,
    LocalStorageUtils,
    TrackingUtils,
    HotelRoomUtils,
    MetricUtils,
    URLUtils,
    withPageContext,
    ErrorBoundary,
} from '../../utils';
import {
    SearchProp,
    SearchPropDefault,
    EntryPoint,
    TripType,
    TripTypeProp,
    DpPaxRestrictionPropsDefault
} from '../../models';
import { SearchService } from '../../services';

export class DynpackManager extends PureComponent {
    constructor(props) {
        super(props);
        const { tripType, setTripType } = props;

        if (tripType !== TripType.ROUND_TRIP) {
            setTripType(TripType.ROUND_TRIP);
        }
    }

    componentDidMount() {
        const { previousSearches, setAllSearch, setHotel, isCurrentSearchPopulated } = this.props;
        const urlParams = URLUtils.getHomeHashParams();
        const isWMP = Config.get('isWMP');
        if (isEmpty(urlParams)) {
            if (!isCurrentSearchPopulated) {
                const lastSearchDynpack = LocalStorageUtils.getJSON('lastSearchDynpack');
                const searchDynpack = SearchService.toNewFormat(lastSearchDynpack);
                if (this.isValidLastSearchDynpack(searchDynpack)) {
                    this.trackSearchLoadsFilled();
                    setAllSearch(searchDynpack);
                } else if (previousSearches.length > 0) {
                    this.trackSearchLoadsFilled();
                    setAllSearch(this.getValidDpFromPreviousSearch(previousSearches));
                }
            }
            const metricFramework = `LOAD_REACT${isWMP ? '_WMP' : ''}`;
            MetricUtils.trackStop(metricFramework);
        }
        setHotel(true);
    }

    componentDidUpdate(prevProps) {
        const { isFetchingGeoLocations, geoLocatedSearch, setAllSearch } = this.props;
        if (!isFetchingGeoLocations && prevProps.isFetchingGeoLocations) {
            this.trackSearchLoadsFilled();
            setAllSearch(geoLocatedSearch);
        }
    }

    getValidDpFromPreviousSearch(previousSearches) {
        const searchDP = previousSearches[0];
        if (searchDP.tripType !== TripType.ROUND_TRIP) {
            searchDP.tripType = TripType.ROUND_TRIP;
            searchDP.segments = [searchDP.segments[0], { id: Date.now() }];
        }
        searchDP.rooms = [HotelRoomUtils.getDefaultRoom(DpPaxRestrictionPropsDefault)];
        searchDP.separateStay = { enabled: false };
        return searchDP;
    }

    trackSearchLoadsFilled = () => {
        const { trackEvent } = this.props;
        const action = TrackingUtils.ACTION.DP;
        trackEvent({ action, label: 'searcher_loads_filled' });
    };

    isValidLastSearchDynpack(search) {
        return search && search.segments.length === 2 && DateUtils.isNotExpired(search.segments[0].date);
    }

    render() {
        return (
            <ErrorBoundary>
                {this.props.render()}
            </ErrorBoundary>
        );
    }
}

DynpackManager.propTypes = {
    render: PropTypes.func.isRequired,
    previousSearches: PropTypes.arrayOf(SearchProp),
    setAllSearch: PropTypes.func.isRequired,
    setHotel: PropTypes.func.isRequired,
    setTripType: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
    geoLocatedSearch: SearchProp,
    tripType: TripTypeProp.isRequired,
    isFetchingGeoLocations: PropTypes.bool,
    isCurrentSearchPopulated: PropTypes.bool,
};

DynpackManager.defaultProps = {
    previousSearches: [],
    geoLocatedSearch: SearchPropDefault,
    isFetchingGeoLocations: false,
    isCurrentSearchPopulated: false,
};

const mapStateToProps = (state) => ({
    previousSearches: getFilteredPreviousSearches(state),
    geoLocatedSearch: getGeoLocatedSearch({
        geoLocations: state.geoLocations.geoLocations,
        allowCitiesWithoutIata: true,
        activeProduct: EntryPoint.DP,
    }),
    tripType: getTripType(state),
    isFetchingGeoLocations: state.geoLocations.isFetching,
    isCurrentSearchPopulated: isCurrentSearchPopulated(state),
});

export const ConnectedDynpackManager = connect(mapStateToProps, {
    setAllSearch,
    setHotel,
    setTripType,
})(withPageContext(DynpackManager));
